import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import LoginHeader from "components/atoms/LoginHeader";
import FooterMobile from "components/atoms/FooterMobile";
import { isMobile } from '../../../helpers/Mobile';

import Icon from 'components/atoms/Icon';

import "./styles.scss";

const Sidebar = ({ open, setOpen }) => {
    return <div className={open ? 'sidebar-container open' : 'sidebar-container close'} onClick={() => setOpen(!open)}>
            {!isMobile && 
            <LoginHeader></LoginHeader>
            }
            <React.Fragment>
                <div className="menu-title">UNIDAD DE FACTURACIÓN</div>
                <div className="menu-submenu">
                    <NavLink className="item" activeClassName="active-item" to="/unidades_adheridas">
                        <div className="item-title">Mis Unidades</div>
                    </NavLink>
                </div>
                <div className="menu-submenu">
                    <NavLink className="item" activeClassName="active-item" to="/consumos">
                        <div className="item-title">Ver Consumos</div>
                    </NavLink>
                </div>
                <hr></hr>
                <div className="menu-title">MI PERFIL</div>
                <div className="menu-submenu">
                    <NavLink
                        className="item mobile-hidden"
                        activeClassName="active-item"
                        to="/cambiar_password"
                    >
                        <div className="item-title">Cambiar Contraseña</div>
                    </NavLink>
                    <NavLink
                        className="item mobile-hidden"
                        activeClassName="active-item"
                        to="/solicitud_baja"
                    >
                        <div className="item-title">Solicitar Baja de Usuario</div>
                    </NavLink>
                </div>
                <hr></hr>
                <div className="menu-title">FACTURAS</div>
                <div className="menu-submenu">
                    <NavLink
                        className="item mobile-hidden"
                        activeClassName="active-item"
                        to="/consulta_descarga_facturas"
                    >
                        <div className="item-title">Consulta y Descarga de Facturas</div>
                    </NavLink>
                </div>
                <div className="menu-submenu">
                    <NavLink
                        className="item mobile-hidden"
                        activeClassName="active-item"
                        to="/consulta_tu_factura"
                    >
                        <div className="item-title">Conocé tu Factura</div>
                    </NavLink>
                </div>
                <hr></hr>
            </React.Fragment>
            {!isMobile && 
            <FooterMobile></FooterMobile>
            }
            </div>
}

export default Sidebar;
